import request from '@/utils/request'
import dayjs from 'dayjs'

interface ViteImportMetaEnv {
  DEV: boolean
  VITE_DATA_CONFIG_SUPPORT_HOST?: string
}

const viteEnv = (import.meta as unknown as { env: ViteImportMetaEnv }).env

/** 获取服务支持接口域名 */
const getDataConfigSupportHost = () => {
  if (viteEnv.DEV) return ''
  return viteEnv.VITE_DATA_CONFIG_SUPPORT_HOST || ''
}

// 获取订阅信息
export function getSubscribeInfo(data: any) {
  return request('/clientbizservice/web/transferGroup?aid=viaimweb&v=1.0&t=' + dayjs(new Date()).format('YYYYMMDDHHmmss'), 'post', data)
}

// 获取服务支持数据
export function getArticleList(data: any) {
  const url = getDataConfigSupportHost() + '/data/base/config/support/v2?aid=viaimweb&v=1.0&t=' + dayjs(new Date()).format('YYYYMMDDHHmmss')
  return request(url, 'post', data, {
    withBase: false,
    resolveDataData: true
  })
}

/*
 * 获取旧服务支持数据
 * 仅用于兼容旧 seeMore 链接，避免旧 id 强行匹配 v2 新数据
 * @param data - 请求参数
 */
export function getLegacyArticleList(data: any) {
  const url = getDataConfigSupportHost() + '/data/base/config/support?aid=viaimweb&v=1.0&t=' + dayjs(new Date()).format('YYYYMMDDHHmmss')
  const legacyData = {
    ...data,
    area_code: data?.area_code === 81 || data?.area_code === 82 ? data.area_code : -1
  }
  console.log('[support/legacy] request params:', legacyData)
  return request(url, 'post', legacyData, {
    withBase: false,
    resolveDataData: true
  }).then((res: any) => {
    console.log('[support/legacy] response:', res)
    return res
  })
}

/** 获取发现页埋点配置 */
export function getMarkLog(data: any) {
  return request('/clientbizservice/market/log?aid=viaimweb&v=1.0&t=' + dayjs(new Date()).format('YYYYMMDDHHmmss'), 'post', data)
}
